/**
 * Format numbers in Indian style (K, L, Cr)
 * - K = Thousands (1,000+)
 * - L = Lakhs (1,00,000+)
 * - Cr = Crores (1,00,00,000+)
 */
export const formatNumber = (value, options = {}) => {
  const { 
    decimals = 1, 
    showCurrency = false,
    forceFormat = false  // Always use K/L/Cr even for small numbers
  } = options;

  if (value === null || value === undefined) return '—';
  
  const num = typeof value === 'string' ? parseFloat(value.replace(/[^0-9.-]/g, '')) : value;
  if (isNaN(num)) return value;

  const absNum = Math.abs(num);
  const sign = num < 0 ? '-' : '';
  const prefix = showCurrency ? '₹' : '';

  // Crores (1,00,00,000+)
  if (absNum >= 10000000) {
    return `${sign}${prefix}${(absNum / 10000000).toFixed(decimals)}Cr`;
  }
  // Lakhs (1,00,000+)
  if (absNum >= 100000) {
    return `${sign}${prefix}${(absNum / 100000).toFixed(decimals)}L`;
  }
  // Thousands (1,000+)
  if (absNum >= 1000) {
    return `${sign}${prefix}${(absNum / 1000).toFixed(decimals)}K`;
  }
  
  // Small numbers
  return `${sign}${prefix}${absNum.toLocaleString('en-IN')}`;
};

/**
 * Format currency in Indian style
 */
export const formatCurrency = (value, decimals = 1) => {
  return formatNumber(value, { showCurrency: true, decimals });
};

/**
 * Format percentage
 */
export const formatPercent = (value, decimals = 1) => {
  if (value === null || value === undefined) return '—';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return value;
  return `${num.toFixed(decimals)}%`;
};

/**
 * Format for chart axis (shorter format)
 */
export const formatAxisValue = (value, isCurrency = false) => {
  if (value === null || value === undefined) return '';
  
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return value;

  const absNum = Math.abs(num);
  const prefix = isCurrency ? '₹' : '';

  if (absNum >= 10000000) return `${prefix}${(absNum / 10000000).toFixed(0)}Cr`;
  if (absNum >= 100000) return `${prefix}${(absNum / 100000).toFixed(0)}L`;
  if (absNum >= 1000) return `${prefix}${(absNum / 1000).toFixed(0)}K`;
  return `${prefix}${absNum}`;
};
